import React, { useState } from 'react';
import { Table as AntTable, Typography } from 'antd';
import { genNumberTable } from '../../../../function/genNumberTable';
const { Title, Text } = Typography;

const headerStyle = {
  color: "white",
  fontWeight: "bold",
  backgroundColor: "#4a4a4a",
  textAlign: 'center',
};

const Table = ({ data = [], loading = false }) => {

  const columns = [
    {
      title: 'Case1',
      dataIndex: 'case1Name',
      key: 'case1Name',
      align: 'center',
      width: 120,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'Case2',
      dataIndex: 'case2Name',
      key: 'case2Name',
      align: 'center',
      width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'Case3',
      dataIndex: 'case3Name',
      key: 'case3Name',
      align: 'center',
      width: 120,
      onHeaderCell: () => ({ style: headerStyle }),
      // render: (text) => (
      //   <span style={{ color: '#ff9800', fontWeight: 'bold' }}>
      //     {text || '-'}
      //   </span>
      // ),
    },
    {
      title: 'จำนวน(ทั้งหมด)',
      // dataIndex: 'countNotHold',
      key: 'countNotHold',
      align: 'center',
      width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (record) => (
        <span >
          {record.countNotHold + record.countHold || '-'}
        </span>
      ),
    },
    {
      title: 'จำนวน',
      dataIndex: 'countNotHold',
      key: 'countNotHold',
      align: 'center',
      width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
      // render: (text) => (
      //   <span style={{ color: '#f44336', fontWeight: 'bold' }}>
      //     {text || '-'}
      //   </span>
      // ),
    },
    {
      title: 'เวลาเฉลี่ย',
      dataIndex: 'avgNotHoldMinutes',
      key: 'avgNotHoldMinutes',
      align: 'center',
      width: 180,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span >{text ? `${Math.floor(text / 60)}:${text % 60} ` : '-'}</span>,
    },
    {
      title: 'จำนวน(Hold)',
      dataIndex: 'countHold',
      key: 'countHold',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || 0}</span>,
    },
    {
      title: 'เวลาเฉลี่ย(Hold)',
      dataIndex: 'avgHoldMinutes',
      key: 'avgHoldMinutes',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span >{text ? `${Math.floor(text / 60)}:${text % 60} ` : '-'}</span>,
    },
    // {
    //   title: 'รายละเอียด',
    //   key: 'details',
    //   align: 'center',
    //   width: 120,
    //   fixed: 'right',
    //   onHeaderCell: () => ({ style: headerStyle }),
    //   render: (_, record) => (
    //     <Button
    //       type="text"
    //       icon={<SearchOutlined style={{ color: '#1890ff', fontSize: '18px' }} />}
    //       onClick={() => handleViewDetails(record)}
    //       style={{ borderRadius: 6 }}
    //     />
    //   ),
    // },
  ];

  return (
    <div style={{ padding: '20px', background: '#fff' }}>
      <div className='overflow-x-auto'>
        <AntTable
          loading={loading}
          dataSource={data}
          columns={columns}
          scroll={{ x: 'max-content' }}
          bordered
          pagination={{
            position: ['topRight'],
            //pageSize: 10,
            pageSizeOptions: [10, 20, 50, 100],
            showSizeChanger: true,
            showQuickJumper: true,
          }}
        />

      </div>


      <style>{`
        .table-row-light {
          background-color: #f5f5f5;
        }
        .ant-table-tbody > tr:hover > td {
          background-color: #e8f4f8 !important;
        }
      `}</style>
    </div>
  );
};

export default Table;

